import * as actions_archive from 'actions/archive-actions';
import * as types from 'actions/action-types';
import React, { useEffect } from 'react';
import _ from 'lodash';
import { Ibox, ModalAlert } from 'enspire-manager-framework';
import { Table } from 'em-table';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

export default function ArchiveSearch(props) {

    /* Hooks ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

	const params = useParams();
    const dispatch = useDispatch();

    const archive = useSelector((store) => store.archive);
    const user_permissions = useSelector((store) => store.users?.user_permissions ?? {});

    const archivedAssetTypes = archive.archived_asset_types?.map((assetType) => {
        return ({ ...assetType, type: types.ASSET_TYPE, name: assetType.value })
    });
    const archivedAssets = archive.archived_assets?.map((asset) => {
        return ({ ...asset, type: types.ASSET, name: asset.name })
    });
    const archivedCustomers = archive.archived_profiles?.filter((o) => o.type == 'customer').map((profile) => {
        return ({ ...profile, type: types.CUSTOMER, name: profile.displayName })
    });
    const archivedEmployees = archive.archived_profiles?.filter((o) => o.type == 'employee').map((profile) => {
        let contact = (profile.contacts && profile.contacts != {}) ? Object.values(profile.contacts)?.[0] : {};	
        return ({ ...profile, type: types.EMPLOYEE, name: (contact?.firstName || contact?.lastName) ? `${contact?.firstName} ${contact?.lastName}` : 'Unknown' })
    });
    const archivedInventory = archive.archived_inventory?.map((stockPart) => {
        return ({ ...stockPart, type: types.INVENTORY, name: stockPart.name })
    });
    const archivedServiceRequests = archive.archived_service_requests?.map((serviceRequest) => {
        return ({ ...serviceRequest, type: types.SERVICE_REQUEST, name: serviceRequest.description })
    });
    const archivedVendors = archive.archived_profiles?.filter((o) => o.type == 'vendor').map((profile) => {
        return ({ ...profile, type: types.VENDOR, name: profile.displayName })
    });
    // only include work orders that are not attached to a deleted Service Request
    const archivedWorkOrders = _.filter(archive.archived_work_orders, (o) => !_.find(archivedServiceRequests, { id: o.serviceRequestId }))?.map((workOrder) => {
        return ({ ...workOrder, type: types.WORK_ORDERS, name: workOrder.description })
    });
    const archivedQuotes = _.filter(archive.archived_quotes, (o) => !_.find(archivedServiceRequests, { id: o.serviceRequestId }))?.map((quote) => {
        return ({ ...quote, type: types.QUOTE, name: quote.description })
    });

    const archived = []
        .concat(archivedAssetTypes)
        .concat(archivedAssets)
        .concat(archivedCustomers)
        .concat(archivedEmployees)
        .concat(archivedInventory)
        .concat(archivedServiceRequests)
        .concat(archivedVendors)
        .concat(archivedWorkOrders)
        .concat(archivedQuotes);

    /* Effects ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

    useEffect(() => {
        dispatch(actions_archive.subArchivedItems(params.handle, types.ARCHIVED_ASSET_TYPES, '/settings/assetTypes'));
        dispatch(actions_archive.subArchivedItems(params.handle, types.ARCHIVED_ASSETS, '/assets/assets'));
        dispatch(actions_archive.subArchivedItems(params.handle, types.ARCHIVED_INVENTORY, '/stock-parts/stock-parts'));
        dispatch(actions_archive.subArchivedItems(params.handle, types.ARCHIVED_PROFILES, '/profiles/profiles'));
        dispatch(actions_archive.subArchivedItems(params.handle, types.ARCHIVED_QUOTES, '/quotes/quotes'));
        dispatch(actions_archive.subArchivedItems(params.handle, types.ARCHIVED_SERVICE_REQUESTS, '/service-requests/service-requests'));
        dispatch(actions_archive.subArchivedItems(params.handle, types.ARCHIVED_WORK_ORDERS, '/work-orders/work-orders'));

        return () => {
            var unsubscribe = archive.archived_asset_types_unsubscribe;
            if (typeof unsubscribe == 'function') unsubscribe();

            var unsubscribe = archive.archived_assets_unsubscribe;
            if (typeof unsubscribe == 'function') unsubscribe();

            var unsubscribe = archive.archived_inventory_unsubscribe;
            if (typeof unsubscribe == 'function') unsubscribe();

            var unsubscribe = archive.archived_profiles_unsubscribe;
            if (typeof unsubscribe == 'function') unsubscribe();

            var unsubscribe = archive.archived_quotes_unsubscribe;
            if (typeof unsubscribe == 'function') unsubscribe();

            var unsubscribe = archive.archived_service_requests_unsubscribe;
            if (typeof unsubscribe == 'function') unsubscribe();

            var unsubscribe = archive.archived_work_orders_unsubscribe;
            if (typeof unsubscribe == 'function') unsubscribe();
        };
    }, []);


    /* Handlers/Actions ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

    const restoreItem = async (item) => {

        ModalAlert({
            title: 'Are you sure?',
            text: "This item will be restored and will appear in the appropriate Search",
            icon: 'warning',
            show_cancel: true,
            confirm_color: '#8FBC8B',
            confirm_text: 'Yes, restore it!',
            callback_success: () => {

                const type = item.type;

                switch (type) {
                    case types.ASSET_TYPE: dispatch(actions_archive.restoreItem(params.handle, item, type, 'Asset Type', '/settings/assetTypes')); break;
                    case types.ASSET: dispatch(actions_archive.restoreItem(params.handle, item, type, 'Asset', '/assets/assets')); break;
                    case types.CUSTOMER: dispatch(actions_archive.restoreProfile(params.handle, item, type)); break;
                    case types.EMPLOYEE: dispatch(actions_archive.restoreProfile(params.handle, item, type)); break;
                    case types.INVENTORY: dispatch(actions_archive.restoreItem(params.handle, item, type, 'Stock Part', '/stock-parts/stock-parts')); break;
                    case types.SERVICE_REQUEST: dispatch(actions_archive.restoreServiceRequest(params.handle, item)); break;
                    case types.VENDOR: dispatch(actions_archive.restoreProfile(params.handle, item, type)); break;
                    case types.QUOTE: dispatch(actions_archive.restoreItem(params.handle, item, type, 'Quote', '/quotes/quotes')); break;
                }                    
            }
        });
    };
    const deleteItem = (type, name, item) => {

        // var text;
        // if (type == 'customer') text = "This Customer will be PERMANENTLY DELETED along with all associated SERVICE REQUESTS, WORK ORDERS, INVOICES and ATTACHMENTS!";
        // if (type == 'service-request') text = "This Service Request will be PERMANENTLY DELETED along with all associated QUOTES, WORK ORDERS, and ATTACHMENTS!";

        // ModalAlert({
        //     title: 'Are you sure?',
        //     text: text,
        //     icon: 'error',
        //     input: 'text',
        //     label: 'To confirm, type "PERMANENTLY DELETE"',
        //     validator: (value) => {
        //         if (value != 'PERMANENTLY DELETE') return 'Phrase Not Correct';
        //     },
        //     show_cancel: true,
        //     confirm_color: '#ED5565',
        //     confirm_text: 'Yes, PERMANENTLY DELETE!',
        //     callback_success: () => {
        //         if (type == 'customer') dispatch(actions_archive.deleteProfile(params.handle, item.id, 'CUSTOMER', null));
        //         if (type == 'employee') dispatch(actions_archive.deleteProfile(params.handle, item.id, 'EMPLOYEE', item));
        //         // if (type == 'service-item') dispatch(actions_archive.deleteServiceItem(params.handle, item.id));
        //         // if (type == 'work-order') dispatch(actions_archive.deleteWorkOrder(params.handle, item.id));
        //     }
        // });
    };

    /* Render ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

    return (

        <Ibox className="mt-3" title={'Archived Items'} no_fade={true}>
            <Table
                data={archived}
                show_limit={false}
                show_search={true}
                highlight_search={true}
                group_by={{ fields: ['type'], direction: ['asc'], display: ['type'], collapsible: true, }}
                columns={[
                    { name: 'Name', field: 'name', width: 45 },
                    { name: 'Archived', field: 'modified', type: 'date', format: 'MMM Do, YYYY h:mm a', width: 25 },
                    ...[ (user_permissions.ARCHIVES_RESTORE) 
                        ? { name: 'Restore', field: 'id', type: 'button', button: { name: 'Restore', className: 'btn-primary btn-xs' }, callback: restoreItem, width: 25 } : {}
                    ],
                    ...[ (user_permissions.ARCHIVES_DELETE) 
                        ? { name: '', field: 'id', type: 'button', button: { name: <i className="far fa-trash-alt"></i>, className: 'btn-default btn-xs' }, callback: deleteItem, width: 5 } : {}
                    ],
                ]}
            />
        </Ibox>
    );
}
